import { Order } from '@apis/index'
import Button from '@components/button'
import Empty from '@components/empty'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import HistoryInfo from '../components/historyInfo'
import HistoryLoading from '../loader/historyLoading'
import { IBookHistory } from '../type'
import { BookList } from '../style'
import { Actions, store } from '@store/index'

const BorrowHistory = ({
  active,
  handleClickItem,
}: {
  active: 'Lend' | 'Borrow'
  handleClickItem: (item: any, type: 'Borrow') => void
}) => {
  const [isFetching, setIsFetching] = useState<boolean>(false)

  const {
    items: borrows,
    loading,
    page,
    totalPages,
  } = useSelector((state: any) => state.borrowOrder)
  const [params, setParams] = useState({
    page: 1,
    limit: 10,
    type: 'Borrow',
  })
  const fetchHistory = async (action: any, params: any) => {
    await Order.getAll(action, 'borrowOrder', params).catch(() => {})
  }
  useEffect(() => {
    if (active === 'Borrow') {
      fetchHistory('set', params)
    }
    return () => {
      store.dispatch(Actions.reset('borrowOrder'))
    }
  }, [])

  return (
    <>
      {loading ? (
        <HistoryLoading />
      ) : !loading && !borrows.length ? (
        <Empty src="noBook" title="No books lent yet!" />
      ) : !!borrows.length ? (
        <>
          <BookList>
            {borrows?.map((item: IBookHistory, index: number) => (
              <HistoryInfo
                key={index.toString()}
                history={item}
                type={active}
                onClick={(history) => {
                  handleClickItem(history, 'Borrow')
                }}
              />
            ))}
            {!!isFetching && <HistoryLoading />}
          </BookList>
        </>
      ) : null}
      {page < totalPages && borrows.length > 0 && (
        <Button
          title="Load More..."
          type="button"
          styleButton="width: fit-content; margin: 16px auto;"
          onClick={async () => {
            const updateParams = {
              ...params,
              page: params?.page + 1,
            }

            if (updateParams?.page <= totalPages) {
              setIsFetching(true)
              await fetchHistory('append', updateParams)
                .then(() => {
                  setParams(updateParams)
                })
                .catch(() => {})
                .finally(() => {
                  setIsFetching(false)
                })
            }
          }}
        />
      )}
    </>
  )
}

export default BorrowHistory
